import type {ReactNode} from 'react'

interface DetailPageGridProps {
    /** Main content — takes 2/3 width on lg+, full width below. Vertically stacks its children. */
    main: ReactNode
    /** Sidebar — takes 1/3 width on lg+, full width below. Consumers wrap in Stack or equivalent. */
    sidebar: ReactNode
    'data-testid'?: string
}

/**
 * Main + sidebar detail-page layout. Grid is single-column below `lg`, 3-column at `lg+`
 * with main spanning 2 columns and sidebar 1 column.
 */
export function DetailPageGrid({main, sidebar, 'data-testid': testId}: DetailPageGridProps) {
    return (
        <div className="grid gap-6 lg:grid-cols-3" data-testid={testId}>
            <div className="lg:col-span-2 space-y-6">
                {main}
            </div>
            <div>
                {sidebar}
            </div>
        </div>
    )
}
